import * as React from 'react';
import makeIcon from './make_icon';
import { jsx as ___EmotionJSX } from "@emotion/react";
var roundFilled = ___EmotionJSX("path", {
  d: "M3.3703 11.5147C3.23428 11.557 3.11186 11.6598 3.05141 11.7822C3.02118 11.8442 3.01514 11.879 3.01514 11.9999C3.01514 12.1208 3.02118 12.1555 3.05141 12.2175C3.10128 12.3173 3.18894 12.4019 3.29322 12.4518L3.37786 12.4911H20.6373L20.7174 12.4487C20.8187 12.3958 20.9018 12.3127 20.9486 12.2175C20.9789 12.1555 20.9849 12.1208 20.9849 11.9999C20.9849 11.879 20.9789 11.8442 20.9486 11.7822C20.9018 11.687 20.8187 11.6039 20.7174 11.551L20.6373 11.5087L12.0227 11.5057C7.28466 11.5042 3.39146 11.5087 3.3703 11.5147Z"
});
var roundLined = ___EmotionJSX("path", {
  d: "M3.3703 11.5147C3.23428 11.557 3.11186 11.6598 3.05141 11.7822C3.02118 11.8442 3.01514 11.879 3.01514 11.9999C3.01514 12.1208 3.02118 12.1555 3.05141 12.2175C3.10128 12.3173 3.18894 12.4019 3.29322 12.4518L3.37786 12.4911H20.6373L20.7174 12.4487C20.8187 12.3958 20.9018 12.3127 20.9486 12.2175C20.9789 12.1555 20.9849 12.1208 20.9849 11.9999C20.9849 11.879 20.9789 11.8442 20.9486 11.7822C20.9018 11.687 20.8187 11.6039 20.7174 11.551L20.6373 11.5087L12.0227 11.5057C7.28466 11.5042 3.39146 11.5087 3.3703 11.5147Z"
});
var sharpFilled = ___EmotionJSX("path", {
  d: "M2.99997 11.5206C2.99544 11.5312 2.99393 11.7534 2.99544 12.0148L2.99997 12.4909L20.9924 12.4985V11.501H12C4.78335 11.501 3.00451 11.504 2.99997 11.5206Z"
});
var sharpLined = ___EmotionJSX("path", {
  d: "M2.99997 11.5206C2.99544 11.5312 2.99393 11.7534 2.99544 12.0148L2.99997 12.4909L20.9924 12.4985V11.501H12C4.78335 11.501 3.00451 11.504 2.99997 11.5206Z"
});
var IconMinus = makeIcon('IconMinus', false, {
  roundFilled,
  roundLined,
  sharpFilled,
  sharpLined
});
export default IconMinus;